export default {"src":"/_next/static/media/navigation-music.ed54f278.gif","height":540,"width":800};